import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};
const Gallery = (props) => {
  return (
    <div className="container ">
      <Slider {...settings}>
        {props.images.map((item, i) => (
          <ImagePreview image={item} key={i} />
        ))}
      </Slider>
    </div>
  );
};

export default Gallery;

export const ImagePreview = ({ image }) => {
  return (
    <div className="main-items pad--large ">
      <div className="card">
        <div className="content-card">
          <div className="img">
            <img src={image} />
          </div>
        </div>
      </div>
    </div>
  );
};
